import { IEvent } from "../interfaces/events.interface";

export interface IEventsState {
    events: IEvent[];
}

export const initialEventsState: IEventsState = {
    events: [],
};